import {
  VuexModule,
  Module,
  MutationAction,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators';

import store from '@/store';
import * as fb from '@/firebase';
import router from '@/router';

import { UserProfile } from '@/models/user-profile';

export interface IUserState {
  currentUser: firebase.User;
  loginRedirect: string | null;
  userProfile: UserProfile | null;
  isLoggedIn: boolean;
}

@Module({ dynamic: true, store, name: 'user' })
export class UserStore extends VuexModule implements IUserState {
  public static SET_SAVED_LIST_IDS_MUTATION = 'SET_SAVED_LIST_IDS';
  public static SET_USER_PROFILE_MUTATION = 'SET_USER_PROFILE';
  public static SET_STARRED_ITEM_IDS_MUTATION = 'SET_STARRED_ITEM_IDS';
  public static SET_FOLLOWED_USER_IDS_MUTATION = 'SET_FOLLOWED_USER_IDS';

  public username = '';
  public currentUserId = '';
  public loginRedirect = null as string;
  public userProfile = null as UserProfile;
  public isLoggedIn = false;
  public currentUser = null as firebase.User;
  public savedListIds: string[] = [];
  public followedUserIds: string[] = [];
  public starredItemIds: string[] = [];

  @Action({ commit: 'SET_CURRENT_USER' })
  public async setCurrentUser({
    currentUser,
    inviteCode
  }: {
    currentUser: firebase.User | null | undefined;
    inviteCode: string;
  }) {
    if (currentUser) {
      fb.usersCollection.doc(currentUser.uid).onSnapshot(
        (res) => {
          if (!res.exists) {
            if (inviteCode) {
              console.log(inviteCode);
              console.log('moving to create profile');
              router.push(`/create_profile?inviteCode=${inviteCode}`);
            } else {
              console.log('no invite code');
              router.push({name: 'SignupWithCode', params: { fromCreateProfileString: 'true' }});
            }
          } else {
            this.context.dispatch(
              'setUserProfile',
              UserProfile.fromFirebaseDoc(res.id, res.data())
            );
          }
        },
        (err) => {
          console.error(err);
        }
      );
    }
    return currentUser;
  }

  @Action({ commit: UserStore.SET_FOLLOWED_USER_IDS_MUTATION })
  public setFollowedUserIds(ids: string[]) {
    return ids;
  }

  @Action({ commit: UserStore.SET_SAVED_LIST_IDS_MUTATION })
  public setSavedListIds(ids: string[]) {
    return ids;
  }

  @Action({ commit: UserStore.SET_STARRED_ITEM_IDS_MUTATION })
  public setStarredItemIds(ids: string[]) {
    return ids;
  }

  @Action({ commit: UserStore.SET_USER_PROFILE_MUTATION })
  public async setUserProfile(val: UserProfile) {
    const redirect = this.loginRedirect;
    if (redirect) {
      router.push(redirect);
    }
    return val;
  }

  @Action({ commit: 'SET_LOGIN_REDIRECT' })
  public setLoginRedirect(val: string) {
    return val;
  }

  @Mutation
  private SET_CURRENT_USER(val: firebase.User) {
    this.currentUser = val;
  }

  @Mutation
  private SET_LOGIN_REDIRECT(val: string) {
    this.loginRedirect = val;
  }

  @Mutation
  private SET_USER_PROFILE(val: UserProfile) {
    this.userProfile = val;
    this.isLoggedIn = !!val;
    this.currentUserId = val.id;
    this.username = val.username;
  }

  @Mutation
  private SET_SAVED_LIST_IDS(val: string[]) {
    this.savedListIds = val;
  }

  @Mutation
  private SET_STARRED_ITEM_IDS(val: string[]) {
    this.starredItemIds = val;
  }

  @Mutation
  private SET_FOLLOWED_USER_IDS(val: string[]) {
    this.followedUserIds = val;
  }

  get userStateReady() {
    return !fb.auth.currentUser || this.isLoggedIn;
  }
}

export const UserModule = getModule(UserStore);
